import React, { useCallback, useEffect, useState } from 'react';
import { injectIntl } from "react-intl";
import { userAvatar } from '../../utils/images';
import { useHistory, useParams } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import PhoneInputComponent from '../Controls/PhoneInput/PhoneInput';
import { arabicConvertor } from '../../utils/Shared';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { getCitiesRequest, getRegionsRequest, getCitiesByRegionRequest } from '../../store/usersLabs/actions';
import { getFamiliesRequest, addFamilyRequest, getPatientRequest, editPatientRequest, validIdRequest, resetValidId } from '../../store/patients/actions';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import MessagesList from './MessagesList';
import GeneralAttachments from './GeneralAttachments/GeneralAttachments';
import MedicalAppointments from './MedicalAppointments/MedicalAppointments';
import EventIcon from '@material-ui/icons/Event';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import AddAppointmentForm from './MedicalAppointments/AddAppointmentForm';
import { addAttachmentRequest } from '../../store/attachments/actions';
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import AddContact from './ContactPersons/AddContact';
import ContactPersons from './ContactPersons/ContactPersons';
import PatientLabtests from './PatientLabtests/PatientLabtests';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PatientRequests from './PatientRequests/PatientRequests';
import { requestSourcesReceive, requestSourcesRequest } from '../../store/requests/actions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SuggessionForm from './PatientLabtests/SuggessionForm';

const StyledAccordion = withStyles({
    root: {
      border: 'none',
      boxShadow: 'rgba(0, 0, 0, 0.09) 0px 3px 12px',
      borderRadius: '20px',
      margin: '0',
      background: '#fff',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
      '&$expanded': {
        margin: '0',
      },
    },
    expanded: {},
  })(Accordion);

function PatientPreviewForm({ intl: { messages } }) {
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [formData, setFormData] = useState({});
    const [cancelConfirmation, setCancelConfirmation] = useState(false);
    const [addFatherFamily, setAddFatherFamily] = useState(false);
    const [addMotherFamily, setAddMotherFamily] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [patientIDFeedback, setPatientIDFeedback] = useState(null);
    const [familyData, setFamilyData] = useState('');
    const lang = localStorage.getItem('lang');
    // Lists
    const [selectedRegion, setSelectedRegion] = useState(0);
    const [selectedBirthDate, setSelectedBirthDate] = useState(moment().format("YYYY-MM-DD"));
    const [showAppsForm, setShowAppsForm] = useState(false);
    const [showContactForm, setShowContactForm] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedApp, setSelectedApp] = useState(null);
    const { requestResources } = useSelector((state) => state.requests);
    const [requestResourcesOptions, setRequestResourcesOptions] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const { allCities, cities, regions } = useSelector((state) => state?.usersLabs);
    const { families, valideFamilyName, patient, validId, IDError } = useSelector((state) => state?.patients);
    const [motherInputValue, setMotherInputValue] = useState(null);
    const [fatherInputValue, setFatherInputValue] = useState(null);
    const [familiesList, setFamiliesList] = useState([{id: 0, name: messages.patients.form.father_link_placeholder}, {id: 'add', name: messages.patients.form.add_new_family}]);
    const [openModal, setOpenModal] = useState(false);
    const relationshipList = [
        {id: 1, name: messages.patients.form.same_family},
        {id: 2, name: messages.patients.form.different_family},
    ];

    const genderList = [
        {id: 1, val: 'Male', name: messages.patients.form.male},
        {id: 2, val: 'Female', name: messages.patients.form.female}
    ];

    const maritalStatus = [
        {id: 1, val: 'Single', name: messages.patients.form.single},
        {id: 2, val: 'Married', name: messages.patients.form.married},
        {id: 3, val: 'Divorced', name: messages.patients.form.divorced},
        {id: 4, val: 'Widow', name: messages.patients.form.widow},
    ];

    const dealingTypes = [
        {id: 1, val: 'Online', name: messages.patients.form.online},
        {id: 2, val: 'Offline', name: messages.patients.form.offline},
    ];

    const programs = [
        {id: 1, name: messages.patients.form.general_program},
        {id: 2, name: messages.patients.form.healthy_family_program},
        {id: 3, name: messages.patients.form.premarital_program},
        {id: 4, name: messages.patients.form.family_wala_program},
    ];

    useEffect(() => {
        if (!requestResources.length) dispatch(requestSourcesRequest());
        return () => {
          dispatch(requestSourcesReceive([]));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
    //add all option
    if (requestResources.length)
        setRequestResourcesOptions([
        { id: 0, name: messages.requests.all_sources },
        ...requestResources,
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestResources]);

    //Get Data
    useEffect(() => {
        if (id && id > 0) {
            dispatch(getPatientRequest(id));
            dispatch(getCitiesRequest());
            dispatch(getRegionsRequest());
            dispatch(getFamiliesRequest());
        }
    }, [dispatch, id]);

     //Regions Change
     useEffect(() => {
        if (selectedRegion > 0) {
            dispatch(getCitiesByRegionRequest(selectedRegion));
            setFormData({
                ...formData,
                city_id: 0,
            });
        } else {
            dispatch(getCitiesRequest());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRegion])

    useEffect(() => {
        if (cities && cities.length > 0) {
            setCitiesList(cities);
        }
    }, [cities]);

    //Get Patient Data
    useEffect(() => {
        if (patient) {
            setFormData({
                id: patient.id,
                can_edit: patient.can_edit,
                profile_image: patient.profile_image,
                has_family_history: patient.has_family_history === 0 ? 0 : patient.has_family_history === 1 ? 1 : null,
                identification_number: patient.identification_number,
                patient_type: patient.patient_type,
                test_type: patient.test_type,
                first_name: patient.first_name || '',
                name: {
                    en: patient.name?.en || '',
                    ar: patient.name?.ar || ''
                },
                father_family_id: patient.father_family_id || 0,
                mother_family_id: patient.mother_family_id || 0,
                parents_relationship: patient.parents_relationship || 0,
                birthday: moment(patient.birthday).format("YYYY-MM-DD") || moment().format("YYYY-MM-DD"),
                birthplace_id: patient.birthplace_id || 0,
                origin_city_id: patient.origin_city_id || 0,
                gender_type: patient.gender_type || 0,
                social_status: patient.social_status || 0,
                source: patient.source || 0,
                contact_method: patient.contact_method || 0,
                program_id: patient.program_id || 0,
                email: patient.email || '',
                phone_number: patient.phone_number ? patient.phone_number?.replace(/\+/g, "") : '',
                city_id: patient.city_id || 0,
                region_id: patient.region_id || 0,
                address: patient.address || '',
                with_contacts: patient.contacts?.length > 0 ? true : false,
                contacts: patient.contacts || [],
            })
            setSelectedBirthDate(patient.birthday)
            setFatherInputValue(patient.father_family_name);
            setMotherInputValue(patient.mother_family_name);
        }
    }, [patient]);

    //Birthday select
    useEffect(() => {
        if (selectedBirthDate) {
            setFormData({
                ...formData,
                birthday: moment(selectedBirthDate).format("YYYY-MM-DD"),
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBirthDate])

    // Validation
    const firstStepValidation = () => {
        let isValid = true;
        if (formData.contact_method === 0) {
            //document.getElementById('dealingType').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.dealing_type_feedback);
        }
        if (formData.source === 0) {
            //document.getElementById('requestChannel').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.request_channel_feedback);
        }
        if (formData.gender_type === 0) {
            //document.getElementById('gender').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.gender_feedback);
        }
        if (formData.social_status === 0) {
            //document.getElementById('status').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.status_feedback);
        }
        if (formData.origin_city_id === 0) {
            //document.getElementById('originCityId').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.city_feedback);
        }
        /* if (formData.address === '') {
            //document.getElementById('address').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.address_placeholder);
        } */
        if (formData.city_id === 0) {
            //document.getElementById('cityId').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.city_feedback);
        }
        if (formData.region_id === 0) {
            //document.getElementById('governorate').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.governorate_feedback);
        }
        if (formData.birthday === new Date()) {
            //document.querySelector('.datetime-picker input').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.birthday_feedback);
        }
        if (formData.birthplace_id === 0) {
            //document.getElementById('birthplaceId').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.birth_city_feedback);
        }
        if (formData.program_id === 0) {
            //document.getElementById('subsPrograms').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.subscription_programs_feedback);
        }
        if (formData.phone_number === '') {
            //document.getElementById('phone').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.mobile_placeholder);
        }
        if (formData.parents_relationship === 0) {
            //document.getElementById('relationship').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.relationship_feedback);
        }
        if (formData.mother_family_id === 0) {
            //document.getElementById('motherLink').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.mother_link_feedback);
        }
        if (formData.father_family_id === 0) {
            //document.getElementById('fatherLink').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.father_link_feedback);
        }
        if (formData.name?.ar === '') {
            //document.getElementById('arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.ar_name_invalid);
        }
        if (formData.name?.en === '') {
            //document.getElementById('enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.en_name_invalid);
        }
        if (formData.first_name === '') {
            //document.getElementById('firstName').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.firstname_placeholder);
        }
        if (formData.identification_number.length < 10 || formData.identification_number.length > 20) {
            //document.getElementById('patientId').style.borderColor = '#d58c8c';
            isValid = false;
            setPatientIDFeedback(messages.patients.form.patientId_feedback);
        }
        if (!formData.has_family_history || !formData.patient_type || !formData.test_type) {
            setFeedback(messages.users.form.all_fields_required);
        }
        //console.log(validId)
        return isValid;
    }

    // Next Function
    const handleNext = (e) => {
        e.preventDefault();
        if (firstStepValidation()) {
            // Save
            let newFatherFamily = false;
            let newMotherFamily = false;

            if (families?.find(family => family.id === formData.father_family_id && family.name === formData.father_family_id)) {
                newFatherFamily = true;
            }
            if (families?.find(family => family.id === formData.mother_family_id && family.name === formData.mother_family_id)) {
                newMotherFamily = true;
            }
        
            setFeedback('');
            
            setTimeout(() => {
                dispatch(editPatientRequest({ 
                    ...formData, 
                    phone_number: `+${formData.phone_number}`,
                    father_family_name: newFatherFamily ? formData.father_family_id : null,
                    father_family_id: newFatherFamily ? null : formData.father_family_id,
                    mother_family_name: newMotherFamily ? formData.mother_family_id : null,
                    mother_family_id: newMotherFamily ? null : formData.mother_family_id,
                }));
            }, 400);
        }
    }

    // Add Family

    useEffect(() => {
        if (formData.father_family_id === 'add') {
            if (formData.mother_family_id === 'add') {
                setFormData({
                    ...formData,
                    mother_family_id: 0,
                })
                setMotherInputValue(null)
            }
            setAddFatherFamily(true);
            setTimeout(() => {
                document.getElementById('addFatherFamily').focus();
                document.getElementById('addFatherFamily').style.borderColor = '#CCC';
            }, 200);
        } else {
            setAddFatherFamily(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.father_family_id])

    useEffect(() => {
        if (formData.mother_family_id === 'add') {
            if (formData.father_family_id === 'add') {
                setFormData({
                    ...formData,
                    father_family_id: 0,
                })
                setFatherInputValue(null)
            }
            setAddMotherFamily(true);
            setTimeout(() => {
                document.getElementById('addMotherFamily').focus();
                document.getElementById('addMotherFamily').style.borderColor = '#CCC';
            }, 200);
        } else {
            setAddMotherFamily(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.mother_family_id])

    useEffect(() => {
        if (valideFamilyName) {
            setTimeout(() => {
                if (addFatherFamily) {
                    setFormData({ ...formData, father_family_id: families[families?.length - 1]?.id });
                    setFatherInputValue(families[families?.length - 1]?.name)
                } else if (addMotherFamily) {
                    setFormData({ ...formData, mother_family_id: families[families?.length - 1]?.id });
                    setMotherInputValue(families[families?.length - 1]?.name)
                }
                setFamilyData('')
            }, 500);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valideFamilyName])

    useEffect(() => {
        if (selectedApp && selectedApp.id) {
            setShowAppsForm(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedApp])

    useEffect(() => {
        if (selectedContact && selectedContact.id) {
            setShowContactForm(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedContact])

    useEffect(() => {
        if (families?.length > 0) {
            setFamiliesList([{id: 0, name: messages.patients.form.father_link_placeholder}, {id: 'add', name: messages.patients.form.add_new_family}, ...families ]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [families]);

    // Blur Event Callback - ID Input
    const blurID = useCallback((e) => {
        if (e.target.value !== '') {
            dispatch(validIdRequest({patient_id: id, identification_number: e.target.value}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handle Blur Event - ID input
    useEffect(() => {
        document.getElementById('patientId')?.addEventListener('blur', blurID);
        return () => {
            document.getElementById('patientId')?.removeEventListener('blur', blurID);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Validate ID input
    useEffect(() => {
        if (validId || document.getElementById('patientId').value === '' || IDError?.length === 0) {
            document.getElementById('patientId').style.borderColor = '#eee';
            setPatientIDFeedback(null);
        } else {
            document.getElementById('patientId').style.borderColor = '#d58c8c';
            setPatientIDFeedback(IDError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validId, IDError]);

    return (
        <div className='userform_container patient_preview_container'>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel1c-content"
                    id="panel1c-header"
                    >
                        <h3>{messages.patients.form.personal_data} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ width: '100%' }}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div className='avatar_input'>
                                    <img src={formData.profile_image ? `${process.env.REACT_APP_BASE_URL}${formData.profile_image}` : userAvatar} alt="Avatar" />
                                    <div id="avatarContainer"><input type="file" name="avatar" id="avatar" /></div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <label className='required'>{messages.patients.form.family_history}</label>
                                <div className='form-group'>
                                    <label className="checkbox-container">{messages.patients.form.yes}
                                        <input type="radio" name="familyHistory" 
                                                disabled={!formData.can_edit}
                                                checked={formData.has_family_history === 1}
                                                value={1}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        has_family_history: 1,
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.patients.form.no}
                                        <input type="radio" name="familyHistory" 
                                                disabled={!formData.can_edit}
                                                checked={formData.has_family_history === 0}
                                                value={0}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData, 
                                                        has_family_history: 0,
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div className='col-md-4'></div>
                        </div>
                        <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-4" style={{ position: 'relative' }}>
                                <label htmlFor="patientId" className='required'>{messages.patients.form.patientId}</label>
                                <input type="text" name="patientId" id="patientId" autoFocus={true}
                                        placeholder={messages.patients.form.patientId_placeholder}
                                        disabled={!formData.can_edit}
                                        value={formData.identification_number}
                                        onChange={e => {
                                            document.getElementById('patientId').style.borderColor = '#eee';
                                            setPatientIDFeedback(null);
                                            dispatch(resetValidId());
                                            setFormData({ ...formData, identification_number: e.target.value })
                                        }} />
                                <span className="patientID_error">{patientIDFeedback}</span>
                            </div>
                            <div className="col-md-4">
                                <label className='required'>{messages.patients.form.customer_type}</label>
                                <div className='form-group'>
                                    <label className="checkbox-container">{messages.patients.form.healthy}
                                        <input type="radio" name="customerType"
                                                disabled={!formData.can_edit}
                                                value={1}
                                                checked={formData.patient_type === 1}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        patient_type: parseInt(e.target.value),
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.patients.form.affected}
                                        <input type="radio" name="customerType"
                                                disabled={!formData.can_edit}
                                                value={2}
                                                checked={formData.patient_type === 2}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        patient_type: parseInt(e.target.value),
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.patients.form.prenatal}
                                        <input type="radio" name="customerType"
                                                disabled={!formData.can_edit}
                                                value={3}
                                                checked={formData.patient_type === 3}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        patient_type: parseInt(e.target.value),
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <label className='required'>{messages.patients.form.test_type}</label>
                                <div className='form-group'>
                                    <label className="checkbox-container">{messages.patients.form.premarital}
                                        <input type="radio" name="testType"
                                                disabled={!formData.can_edit}
                                                value={1}
                                                checked={formData.test_type === 1}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        test_type: parseInt(e.target.value),
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.patients.form.pregnancy}
                                        <input type="radio" name="testType"
                                                disabled={!formData.can_edit}
                                                value={2}
                                                checked={formData.test_type === 2}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        test_type: parseInt(e.target.value),
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.patients.form.individual}
                                        <input type="radio" name="testType"
                                                disabled={!formData.can_edit}
                                                value={3}
                                                checked={formData.test_type === 3}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        test_type: parseInt(e.target.value),
                                                    });
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="firstName" className='required'>{messages.patients.form.firstname}</label>
                                <input type="text" name="firstName" id="firstName"
                                        placeholder={messages.patients.form.firstname_placeholder}
                                        disabled={!formData.can_edit}
                                        value={formData.first_name} 
                                        onChange={e => {
                                            document.getElementById('firstName').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, first_name: arabicConvertor(e.target.value) })
                                            }} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="arname" className='required'>{messages.patients.form.ar_name}</label>
                                <input type="text" name="arname" id="arname"
                                        placeholder={messages.patients.form.ar_name_placeholder}
                                        disabled={!formData.can_edit}
                                        value={formData.name?.ar}
                                        onChange={e => {
                                            document.getElementById('arname').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, name: { ...formData.name, ar: arabicConvertor(e.target.value) } })
                                            }} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="enname" className='required'>{messages.patients.form.en_name}</label>
                                <input type="text" name="enname" id="enname"
                                        placeholder={messages.patients.form.en_name_placeholder}
                                        disabled={!formData.can_edit}
                                        value={formData.name?.en} 
                                        onChange={e => {
                                            document.getElementById('enname').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, name: { ...formData.name, en: e.target.value } })
                                            }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="fatherLink" className='required'>{messages.patients.form.father_link}</label>
                                {
                                    addFatherFamily ? (
                                        <div className="family-input">
                                            <input type="text" name="addFatherFamily" id="addFatherFamily"
                                                    placeholder={messages.patients.form.add_new_family}
                                                    value={familyData} 
                                                    onChange={e => setFamilyData(e.target.value)}
                                                    onKeyDown={e => {
                                                        if (e.key === "Enter") {
                                                            if (familyData.length > 0) {
                                                                dispatch(addFamilyRequest(familyData))
                                                            }
                                                        }
                                                    }} />
                                            <CheckIcon className="add family-icon"
                                                onClick={() => {
                                                    if (familyData.length > 0) {
                                                        dispatch(addFamilyRequest(familyData))
                                                    }
                                                }}
                                                />
                                            <CloseIcon className="family-icon" 
                                                onClick={() => {
                                                    setFormData({ ...formData, father_family_id: 0 });
                                                    setFamilyData('');
                                                    setAddFatherFamily(false)
                                                }} 
                                                    />
                                        </div>
                                    ) : (
                                        <div className="auto_complete">
                                            <Autocomplete
                                                id="fatherLinkAutoComplete"
                                                value={familiesList?.find(fam => fam.id === formData.father_family_id) || null}
                                                onChange={(event, newValue) => {
                                                    //document.getElementById('fatherLink').style.borderColor = '#eee';
                                                    setFeedback('');
                                                    setFormData({ ...formData, father_family_id: newValue.id })
                                                }}
                                                inputValue={fatherInputValue}
                                                onInputChange={(event, newInputValue) => {
                                                    setFatherInputValue(newInputValue);
                                                }}
                                                options={familiesList}
                                                getOptionSelected={(option) => option.id === formData.father_family_id}
                                                getOptionLabel={(option) => option.name || fatherInputValue}
                                                style={{ width: '100%' }}
                                                renderInput={(params) => (
                                                    <div ref={params.InputProps.ref}>
                                                        <input placeholder={messages.patients.form.father_link_placeholder} type="text" name="fatherLink" id="fatherLink" {...params.inputProps} />
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="motherLink" className='required'>{messages.patients.form.mother_link}</label>
                                {
                                    addMotherFamily ? (
                                        <div className="family-input">
                                            <input type="text" name="addMotherFamily" id="addMotherFamily"
                                                    placeholder={messages.patients.form.add_new_family}
                                                    value={familyData} 
                                                    onChange={e => setFamilyData(e.target.value)}
                                                    onKeyDown={e => {
                                                        if (e.key === "Enter") {
                                                            if (familyData.length > 0) {
                                                                dispatch(addFamilyRequest(familyData))
                                                            }
                                                        }
                                                    }} />
                                            <CheckIcon className="add family-icon" 
                                                onClick={() => {
                                                    if (familyData.length > 0) {
                                                        dispatch(addFamilyRequest(familyData))
                                                    }
                                                }}
                                                />
                                            <CloseIcon className="family-icon" 
                                                onClick={() => {
                                                    setFormData({ ...formData, mother_family_id: 0 })
                                                    setFamilyData('');
                                                    setAddMotherFamily(false)}
                                                } 
                                                />
                                        </div>
                                    ) : (
                                        <div className="auto_complete">
                                            <Autocomplete
                                                id="motherLinkAutoComplete"
                                                value={familiesList?.find(fam => fam.id === formData.mother_family_id) || null}
                                                onChange={(event, newValue) => {
                                                    //document.getElementById('motherLink').style.borderColor = '#eee';
                                                    setFeedback('');
                                                    setFormData({ ...formData, mother_family_id: newValue.id })
                                                }}
                                                inputValue={motherInputValue}
                                                onInputChange={(event, newInputValue) => {
                                                    setMotherInputValue(newInputValue);
                                                }}
                                                options={familiesList}
                                                getOptionSelected={(option) => option.id === formData.mother_family_id}
                                                getOptionLabel={(option) => option.name || motherInputValue}
                                                style={{ width: '100%' }}
                                                renderInput={(params) => (
                                                    <div ref={params.InputProps.ref}>
                                                    <input placeholder={messages.patients.form.mother_link_placeholder} type="text" name="motherLink" id="motherLink" {...params.inputProps} />
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="relationship" className='required'>{messages.patients.form.relationship}</label>
                                <select name="relationship" id="relationship"
                                        value={formData.parents_relationship}
                                        disabled={!formData.can_edit}
                                        onChange={e => {
                                            document.getElementById('relationship').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, parents_relationship: parseInt(e.target.value) })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.relationship_placeholder}</option>
                                    {relationshipList.map(relation => <option key={relation.id} value={relation.id}>{relation.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="phone" className='required'>{messages.patients.form.mobile}</label>
                                <PhoneInputComponent name="phone" id="phone" lang={lang}
                                    myplaceholder={messages.users.form.mobile_placeholder}
                                    disabled={!formData.can_edit}
                                    myvalue={formData.phone_number}
                                    onValueChange={(val) => {
                                        document.getElementById('phone').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, phone_number: val })
                                        }}
                                    />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="email">{messages.patients.form.email}</label>
                                <input type="email" name="email" id="email"
                                        placeholder={messages.patients.form.email_placeholder}
                                        disabled={!formData.can_edit}
                                        value={formData.email} 
                                        onChange={e => {
                                            document.getElementById('email').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, email: e.target.value })
                                            }} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="subsPrograms" className='required'>{messages.patients.form.subscription_programs}</label>
                                <select name="subsPrograms" id="subsPrograms"
                                        disabled={!formData.can_edit}
                                        value={formData.program_id}
                                        onChange={e => {
                                            document.getElementById('subsPrograms').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, program_id: parseInt(e.target.value) })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.subscription_programs_placeholder}</option>
                                    {programs.map(program => <option key={program.id} value={program.id}>{program.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="status" className='required'>{messages.patients.form.marital_status}</label>
                                <select name="status" id="status"
                                        disabled={!formData.can_edit}
                                        value={formData.social_status}
                                        onChange={e => {
                                            document.getElementById('status').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, social_status: e.target.value })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.marital_status_placeholder}</option>
                                    {maritalStatus?.map(status => <option key={status.id} value={status.id}>{status.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="gender" className='required'>{messages.patients.form.gender}</label>
                                <select name="gender" id="gender"
                                        disabled={!formData.can_edit}
                                        value={formData.gender_type}
                                        onChange={e => {
                                            document.getElementById('gender').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, gender_type: e.target.value })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.gender_placeholder}</option>
                                    {genderList?.map(gender => <option key={gender.id} value={gender.id}>{gender.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="birthday" className='required'>{messages.patients.form.birthday}</label>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        id="date-picker-dialog"
                                        format="dd/MM/yyyy"
                                        emptyLabel="DD/MM/YYYY"
                                        value={selectedBirthDate}
                                        onChange={setSelectedBirthDate}
                                        className="datetime-picker"
                                        disabled={!formData.can_edit}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="birthplaceId" className='required' >{messages.patients.form.birth_city}</label>
                                <select name="birthplaceId" id="birthplaceId"
                                        disabled={!formData.can_edit}
                                        value={formData.birthplace_id}
                                        onChange={e => {
                                            document.getElementById('birthplaceId').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, birthplace_id: parseInt(e.target.value)})
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.birth_city_placeholder}</option>
                                    {allCities?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="originCity" className='required' >{messages.patients.form.origin_city}</label>
                                <select name="originCity" id="originCity"
                                        disabled={!formData.can_edit}
                                        value={formData.origin_city_id}
                                        onChange={e => {
                                            document.getElementById('originCity').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, origin_city_id: parseInt(e.target.value)})
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.origin_city_placeholder}</option>
                                    {allCities?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="governorate" className='required'>{messages.patients.form.governorate}</label>
                                <select name="governorate" id="governorate"
                                        disabled={!formData.can_edit}
                                        value={formData.region_id}
                                        onChange={e => {
                                            document.getElementById('governorate').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, region_id: parseInt(e.target.value) })
                                            setSelectedRegion(e.target.value)
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.governorate_placeholder}</option>
                                    {regions?.map(gov => <option key={gov.id} value={gov.id}>{gov.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="cityId" className='required'>{messages.patients.form.city}</label>
                                <select name="cityId" id="cityId"
                                        disabled={!formData.can_edit}
                                        value={formData.city_id}
                                        onChange={e => {
                                            document.getElementById('cityId').style.borderColor = '#eee';
                                            setFormData({ ...formData, city_id: parseInt(e.target.value) })
                                            setFeedback('');
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.city_placeholder}</option>
                                        {citiesList?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}                                
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="address">{messages.patients.form.address}</label>
                                <input type="text" name="address" id="address"
                                        placeholder={messages.patients.form.address_placeholder}
                                        disabled={!formData.can_edit}
                                        value={formData.address} 
                                        onChange={e => {
                                            document.getElementById('address').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, address: e.target.value })
                                            }} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="requestChannel" className='required'>{messages.patients.form.request_channel}</label>
                                <select name="requestChannel" id="requestChannel"
                                        disabled={!formData.can_edit}
                                        value={formData.source}
                                        onChange={e => {
                                            document.getElementById('requestChannel').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, source: e.target.value })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.request_channel_placeholder}</option>
                                    {requestResourcesOptions?.map(source => <option key={source.id} value={source.id}>{source.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="dealingType" className='required'>{messages.patients.form.dealing_type}</label>
                                <select name="dealingType" id="dealingType"
                                        disabled={!formData.can_edit}
                                        value={formData.contact_method}
                                        onChange={e => {
                                            document.getElementById('dealingType').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, contact_method: e.target.value })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.dealing_type_placeholder}</option>
                                    {dealingTypes?.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4"></div>
                            <div className="col-md-4"></div>
                        </div>
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="acc_actions" style={{ justifyContent: 'flex-start', visibility: 'hidden' }}>
                            <button type="button" className="link" disabled={!formData.can_edit}>
                                {messages.patients.form.btn_link}
                            </button>
                        </div>
                        <p id="feedback0" className="feedback0">{feedback}</p>
                        <div className="acc_actions">
                            <button type="button" className="cancel" onClick={() => setCancelConfirmation(true)}>
                                {messages.patients.form.btn_cancel}
                            </button>
                            <button type="button" onClick={(e) => handleNext(e)} disabled={addFatherFamily || addMotherFamily || !formData?.can_edit}>
                                {messages.patients.form.btn_save}
                            </button>
                        </div>
                    </div>
                </AccordionActions>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel22c-content"
                    id="panel22c-header">
                    <h3>{messages.patients.form.patient_requests} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <PatientRequests />
                </AccordionDetails>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel2c-content"
                    id="panel2c-header">
                    <h3>{messages.patients.form.messages_title} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <MessagesList />
                </AccordionDetails>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel3c-content"
                    id="panel3c-header">
                    <h3>{messages.patients.contacts.title} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <ContactPersons disabled={!formData.can_edit} patientId={id} setEditContact={(contact) => setSelectedContact(contact)} />
                </AccordionDetails>
                <AccordionActions>
                        <div className="acc_actions">
                            <button type="button" disabled={!formData.can_edit} className="link" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedContact(null);
                                        setShowContactForm(true);
                                    }}>
                                <PersonAddIcon /> {messages.patients.contacts.add}
                            </button>
                        </div>
                </AccordionActions>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel3c-content"
                    id="panel3c-header">
                    <h3>{messages.patients.attachments.title} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <GeneralAttachments disabled={!formData.can_edit} />
                </AccordionDetails>
                <AccordionActions>
                        <div className="acc_actions">
                            <button type="button" disabled={!formData.can_edit} className="link" onClick={(e) => {
                                e.preventDefault();
                                document.getElementById('add-attachment').click();
                            }}>
                                <AttachFileIcon /> {messages.patients.attachments.btn}
                            </button>
                            <div id="pdf-input"><input id="add-attachment" type='file'
                                                        accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" 
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            if (file) {
                                                                const fileData = new FormData();
                                                                fileData.append('attachment', file);
                                                                fileData.append('patient_id', id);
                                                                const patientId = id;
                                                                dispatch(addAttachmentRequest(fileData, patientId));
                                                            }
                                                        }} /></div>
                        </div>
                </AccordionActions>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel4c-content"
                    id="panel4c-header">
                    <h3>{messages.patients.appointments.title} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <MedicalAppointments disabled={!formData.can_edit} patientId={id} setEditApp={(app) => setSelectedApp(app)} />
                </AccordionDetails>
                <AccordionActions>
                        <div className="acc_actions">
                            <button type="button" disabled={!formData.can_edit} className="link" onClick={() => setShowAppsForm(true)} >
                                <EventIcon /> {messages.patients.appointments.btn}
                            </button>
                        </div>
                </AccordionActions>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <StyledAccordion defaultExpanded>
                <AccordionSummary
                    aria-controls="panel4c-content"
                    id="panel4c-header">
                    <h3>{messages.patients.labtests.title} <ExpandMoreIcon /></h3>
                </AccordionSummary>
                <AccordionDetails>
                    <PatientLabtests disabled={!formData.can_edit} patientId={id} patientCityId={formData?.city_id} />
                </AccordionDetails>
                <AccordionActions>
                        <div className="acc_actions">
                            <button type="button" className="link" onClick={() => setOpenModal(true)} >
                                <AddCircleOutlineIcon /> {messages.patients.labtests.btn}
                            </button>
                        </div>
                </AccordionActions>
            </StyledAccordion>
            <div className='divider'>&nbsp;</div>
            <AddAppointmentForm show={showAppsForm} close={() => {setSelectedApp(null); setShowAppsForm(false)}} patientId={id} selectedApp={selectedApp} />
            <AddContact show={showContactForm} close={() => { setSelectedContact(null); setShowContactForm(false)}} patientId={id} selectedContact={selectedContact} />
            <SuggessionForm show={openModal} close={() => setOpenModal(false)} patientId={id} />
            <ConfirmDialog show={cancelConfirmation} 
                     onCancel={() => setCancelConfirmation(false)}
                     onConfirm={() => {
                        setCancelConfirmation(false);
                        // clear();
                        history.goBack();
                     }}
                     icon={null}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}

export default injectIntl(PatientPreviewForm);
